<div
  bsModal
  #listDetailsEditorModal="bs-modal"
  [config]="{
    show: false,
    keyboard: !modalControl.isSaving,
    ignoreBackdropClick: modalControl.isSaving
  }"
  [rlTrapFocus]="{ setReturnFocus: '#edit-list-btn' }"
  (onHidden)="onClose()"
  class="modal fade"
  tabindex="-1"
  role="dialog"
  aria-labelledby="list-details-editor-modal"
  aria-hidden="true"
>
  <div class="modal-dialog">
    <div class="modal-content">
      <div class="modal-header">
        <h2
          class="modal-title"
          id="list-details-editor-modal"
          i18n="@@listDetailsEditorModal-heading-editListDetails"
        >
          Edit details
        </h2>
      </div>

      <rl-list-details-editor
        [editableList]="editableList"
        [currentUserPermissions]="currentUserPermissions"
        [licenses]="licenses"
        [timePeriods]="timePeriods"
        [modalControl]="modalControl"
        (close)="onClose()"
        (save)="onSave($event)"
      >
      </rl-list-details-editor>
    </div>
  </div>
</div>
